import { render, staticRenderFns } from "./AddressBlock.vue?vue&type=template&id=6feba7e3&lang=html&"
import script from "./AddressBlock.vue?vue&type=script&lang=js&"
export * from "./AddressBlock.vue?vue&type=script&lang=js&"
import style0 from "./AddressBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports